import { SelectionModel } from '@angular/cdk/collections';
import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit, Optional, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { AuthService } from 'app/auth/auth.service';
import { ServiceList } from 'app/billing/Models/billing.Models';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { DynamicHelpListComponent } from 'app/EMR/Doctor/doctor-other-info/dynamic-help-list/dynamic-help-list.component';
import { HelpListPopupComponent } from 'app/EMR/Doctor/doctor-other-info/help-list-popup/help-list-popup.component';
import { DosageMasterModel } from 'app/EMR/DoctorModels/dosageMaster.model';
import { DosageTimeDetailModal } from 'app/EMR/DoctorModels/dosageTimeDetail.model';
import { MedicineModal } from 'app/EMR/DoctorModels/medicine.model';
import { MedicineCatModal } from 'app/EMR/DoctorModels/medicineCategory.model';
import { MedicineMfgModal } from 'app/EMR/DoctorModels/medicineMfg.model';
import { EMRService } from 'app/EMR/EMR.service';
import { HelplistService } from 'app/helplist.service';
import { VoiceRecognitionService } from 'app/masters/service/voice-recognition.service';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { ExportService } from 'app/reports/services/export.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MedicineCatgeoryMasterComponent } from '../medicine-catgeory-master/medicine-catgeory-master.component';
import { DosageMasterComponent } from '../dosage-master/dosage-master.component';
import { MedicineManufacturerMasterComponent } from '../medicine-manufacturer-master/medicine-manufacturer-master.component';
@Component({
  selector: 'app-medicine-master',
  templateUrl: './medicine-master.component.html',
  styleUrls: ['./medicine-master.component.scss']
})
export class MedicineMasterComponent implements OnInit {
    destroy$: Subject<boolean> = new Subject<boolean>();
   private rowClicked: any;
   private dosedataArray: any = [];
   private searchDose: any;
   private searchmedicine: any;
   private todaysdate = new Date();
    private selection = new SelectionModel<ServiceList>(true, []);
    private medicinecategories_ds: any = new MatTableDataSource<MedicineCatModal>();
    private medicine_ds: any = new MatTableDataSource<MedicineModal>();
    private addmedicineobject: MedicineModal = {};
    private addMedicineMfg: MedicineMfgModal = {};
    private  dosageTimedetails: DosageTimeDetailModal[] = [];
    private  dosageMasterdataModel: DosageMasterModel[] = [];
    private dosageMasterdataobj: DosageMasterModel = {};
    private dosageTimedetailsobj: DosageTimeDetailModal = {};
    private SelectedMedicineArray: any = [];
    private medicinearray: any = [];
    private MfgMasterArray: any = [];
    private routemainArray: any = [];
    private languagemasterArray: any = [];
    private fontfamilyArray: any = [];
    private searchFontFamily: any;
    private searchlanguage: any;
    private searchManufacturer: any;
    private searchroute: any;
    private searchdose: any;
    private showspinner: boolean = false;
    private MfgMasterArrayList: any = [];
    private searchMfgMaster: any;
    private searchRoute: any;
    private searchDoagecode: any;
    private timeFormatcheck: any;
    private fontFamilytype: String = '';
    private stype:any;
    displayedColumns_medinicecategories: string[] = ['medicineCatName'];
    popbutton: number;
  searchValue: string;
  medData: any;
    constructor(private service : VoiceRecognitionService,private dialog: MatDialog, public dialogRef: MatDialogRef<MedicineMasterComponent>,
      private helplistservice: HelplistService, private datepipe: DatePipe,
      private authService: AuthService, private dashboardService: DashboardService,  @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
      private opdvisitService: OpdVisitService, private emrService: EMRService, private exportdata: ExportService) {
        this.service.init()
       }
  
  
    ngOnInit(): void {
      this.popbutton = 0;
      if (this.data.id != null && this.data.id != undefined) {
        this.popbutton = this.data.id;
      }
     
      this.dosageMasterdataModel = [];
      this.dosageMasterdataobj = {};
      this.dosageTimedetails = [];
      this.dosageTimedetailsobj = {};
      this.languagemasterArray=[];
      this.MfgMasterArrayList=[];
      this.fontfamilyArray=[];
      this.routemainArray = [];
      this.MfgMasterArray=[];
      this.SelectedMedicineArray=[];
      this.medicinearray=[];
      this.showspinner=false;
      this.GetDosageMaster(0,0,0);
      this.timeFormatcheck = 'AM';
      this.GetMedicineMfgMaster(0);
      this.dosageMasterdataobj.fK_LanguageId = 1;
      this.addmedicineobject = {};
      this.GetMedicineMaster(0,0,0,0)
      this.rowClicked = -1;
      this.get_drugallergy()
      this.GetMedicineCategoryMaster(0);
      this.getRoutedata(0);
      this.GetLanguageMaster(0);
      this.stype='S';
      this.fontfamilyArray = this.emrService.fontFamilies;
    }
    searchType(event) {
      this.stype = event;
    }
    startService(){
      this.service.MStext = '';
      this.service.start('Medicine Search')
    }
  
    stopService(){
      this.service.stop('Medicine Search');
      if(this.service.MStext){
       
        this.filtermedicinedatspeach(this.service.MStext,1);
      }
    }
    seachfontfamily(event: any) {
      
      if (event != null) {
        this.fontFamilytype = event+'!important';
      } else {
       this.fontFamilytype ='';
      }
    }
    GetLanguageMaster(lngid) {
      this.languagemasterArray = [];
      this.emrService.GetLanguageMaster(lngid).pipe(takeUntil(this.destroy$)).subscribe((x: any) => {
        this.languagemasterArray = x.filter(item => item.isActive == true);
      });
    }
    get_drugallergy() {
      this.emrService.drugallergy = [];
      this.emrService.get_allergies().pipe(takeUntil(this.destroy$)).subscribe(
        data => this.success_drugallergy(data), err => this.failed_drugallergy(err)
      )
  
    }
  
    success_drugallergy(data) {
      if(data.statusCode ==8){
  
      }else{
        this.emrService.drugallergy = data;
      }
    }
  
    failed_drugallergy(err) {
  
    }
  
    GetDosageMaster(doseid,type,seachtype) {
      this.emrService.GetDosageMaster(doseid,type,seachtype).pipe(takeUntil(this.destroy$)).subscribe(item => {
        this.dosedataArray = item;
       
      });
    }
    onDosechange(e: any, index: number) {
      
      if (e != null) {
        let doseid = this.dosedataArray.filter(item => item.dosageCode.toLowerCase() == e.toLowerCase());
        this.SelectedMedicineArray[index].fK_DosageId = doseid[0].pK_DosageId;
        this.SelectedMedicineArray[index].dosageCode = e;
        this.SelectedMedicineArray[index].dosageDescription = doseid[0].dosageDescription;
      }
    }
    onRoutechange(e: any, index: number) {
      if (e != null) {
        let routeid = this.routemainArray.filter(item => item.routeName.toLowerCase() == e.toLowerCase());
        this.SelectedMedicineArray[index].fK_RouteId = routeid[0].pK_RouteId;
        this.SelectedMedicineArray[index].route = e;
      }
    }
  
    GetMedicineMfgMaster(medcineid) {
      this.MfgMasterArrayList = [];
      this.MfgMasterArray = [];
      this.emrService.GetMedicineMfgMaster(medcineid).pipe(takeUntil(this.destroy$)).subscribe(data => this.successMfgMaster(data), err => this.failed_category(err))
    }
  
    successMfgMaster(data) {
      this.MfgMasterArrayList = data;
      this.MfgMasterArray = data.filter(item => item.isActive == true);
    }
  
    mgfCOmpany(mgfid) {
      let mgfName = this.MfgMasterArray.filter(item => item.pK_ManufacturerId == mgfid);
      if (mgfName.length > 0) {
        return mgfName[0].manufacturerName;
      } else {
        return null;
      }
    }
    
    failed_category(err) {
  
    }
    filtermedicinedatspeach(event,type){
      if(event.length >=3 ){
        this.emrService.GetMedicineMaster(0,event,this.stype,0).pipe(takeUntil(this.destroy$)).subscribe((item:any)=>{
          if(type ==1){
            this.medicine_ds = new MatTableDataSource(item.filter(item=>item.isActive ==true).slice());
          }else if(type ==2){
            this.medicinearray = item;
          }
         
         });
      }
    }
  globalmedicinearray:any=[];
    filtermedicinedata(keytype,type){
      if (keytype.key === 'Enter') {
        keytype.preventDefault();
        if(keytype.target.value.length >=3 ){
          this.emrService.GetMedicineMaster(0,keytype.target.value,this.stype,0).pipe(takeUntil(this.destroy$)).subscribe((item:any)=>{
          
            if(type ==1){
              this.medicine_ds = new MatTableDataSource(item.filter(item=>item.isActive ==true).slice());
            }else if(type ==2){
              this.medicinearray = item;
            }
           
           });
        }
      }else{
      const finddata=this.filerdata(this.globalmedicinearray,keytype.target.value);
      if(finddata.length >0){
        if(type ==1){
          this.medicine_ds.data =finddata;
        }else if(type ==2){
          this.medicinearray =finddata;
        }
       
      }else{
        this.medicine_ds.data =[];
        this.medicinearray =[];
        if(keytype.target.value.length >=3 ){
          var pdata =0;
       if(keytype.target.value !=null && keytype.target.value !=''){
        pdata= keytype.target.value
       }else{
          pdata =0;
       }
       this.emrService.GetMedicineMaster(0,pdata,this.stype,0).pipe(takeUntil(this.destroy$)).subscribe((item:any)=>{
      
        if(type ==1){
          this.medicine_ds = new MatTableDataSource(item.filter(item=>item.isActive ==true).slice());
        }else if(type ==2){
          this.medicinearray = item;
        }
       
       });
      }
      }
    }
     }
    //  filerdata(items: any[], searchText: string){ 
      
    //      if(this.stype=='S'){
    //       let smallchar=searchText?searchText.toLowerCase():'';
    //       return items ? items.filter(item => item.medicineName?.toLowerCase().indexOf(smallchar) === 0):[];
    //     }else{
    //       return items ? items.filter(item => item.medicineName.search(new RegExp(searchText, 'i')) > -1) : [];
    //     }
    //  }
    filerdata(array: any[], searchText: string): any[] {
  searchText = searchText.toLowerCase();
  return array.filter(item => {
    return (
      (item.medicineName?.toLowerCase().includes(searchText)) ||
      (item.medicineCategory?.toLowerCase().includes(searchText)) ||
      (item.manufacturerName?.toLowerCase().includes(searchText)) ||
      (item.route?.toLowerCase().includes(searchText)) ||
      (item.qty?.toString().toLowerCase().includes(searchText)) ||
      (item.type?.toLowerCase().includes(searchText)) ||
      (item.dosageCode?.toLowerCase().includes(searchText)) ||
      (item.days?.toString().toLowerCase().includes(searchText)) ||
      (item.daysUnit?.toLowerCase().includes(searchText)) ||
      (item.drugName?.toLowerCase().includes(searchText)) ||
      (item.remarks?.toLowerCase().includes(searchText))
    );
  });
}

    GetMedicineMaster(pK_MedicineId,type,searchtype,categoryid) {
   
      this.emrService.GetMedicineMaster(pK_MedicineId,type,searchtype,categoryid).pipe(takeUntil(this.destroy$)).subscribe(data => this.successMedicine(data), err => this.failed_category(err))
    }
  
    successMedicine(data) {
      this.globalmedicinearray =[];
      this.medicinearray = [];
      this.globalmedicinearray=data;
      this.medicinearray = data;
      this.medData = data
      this.medicine_ds = new MatTableDataSource(data.filter(item=>item.isActive ==true).slice());
    }
  
    ngOnDestroy() {
      this.destroy$.next(true);
      this.destroy$.unsubscribe();
      this.globalmedicinearray =null;
      this.medicinearray = null;
      this.dosageMasterdataModel = null;
      this.dosageMasterdataobj = null;
      this.dosageTimedetails = null;
      this.dosageTimedetailsobj = null;
      this.languagemasterArray=null;
      this.MfgMasterArrayList=null;
      this.fontfamilyArray=null;
      this.routemainArray = null;
      this.MfgMasterArray=null;
      this.SelectedMedicineArray=null;
      this.medicinearray=null;
      this.showspinner=null;
      this.medicine_ds=null;
      this.languagemasterArray=null;
      this.fontfamilyArray=null;
      this.searchFontFamily=null;
      this.searchlanguage=null;
      this.searchManufacturer=null;
      this.searchroute=null;
      this.searchdose=null;
      this.showspinner=null;
      this.MfgMasterArrayList=null;
      this.searchMfgMaster=null;
      this.searchRoute=null;
      this.searchDoagecode=null;
      this.timeFormatcheck=null;
      this.fontFamilytype=null;
    }
    filtermedicinelist(row) {
      let mdata = this.medicinearray.filter(item => item.fK_CategoryId == row.pK_MedicineCategoryId);
      this.medicine_ds = new MatTableDataSource(mdata.filter(item=>item.isActive ==true).slice());
    }

    stockbalqty:any=null;
    selectRow(row) {
      this.selection.toggle(row);
      var checkarraydata = this.SelectedMedicineArray.filter(item => item.pK_MedicineId == row.pK_MedicineId);
      if (checkarraydata.length > 0) {
        this.SelectedMedicineArray = this.SelectedMedicineArray.filter(item => item.pK_MedicineId != row.pK_MedicineId);
        if(this.SelectedMedicineArray.length ==0){
          this.stockbalqty =null; 
        }
       
      } else {
        row.isEdit = false;
        row.pK_TranId = 0;
        let rowdoseid = this.dosedataArray.filter(item => item.dosageCode.toLowerCase() == row.dosageCode.toLowerCase());    
        row.dosageDescription = rowdoseid[0]?.dosageDescription;     
        this.SelectedMedicineArray.push(row);
  
      }
  
      this.SelectedMedicineArray = this.SelectedMedicineArray.reduce((unique, o) => {
        if (!unique.some(obj => obj.medicineName === o.medicineName && obj.pK_MedicineId === o.pK_MedicineId)) {
          unique.push(o);
        }
        return unique;
      }, []);
      var queueproty = this.opdvisitService.documentrul.filter(item => item?.propertyName == "NeedStockinPrescription");
      if(queueproty.length >0 && queueproty[0]?.propertyValue =='Y' && queueproty[0]?.propertyValue !=null && queueproty[0]?.propertyValue !=undefined ){
        this.stockbalqty =row.balanceQty
      }else{
        this.stockbalqty =null; 
      }
    
  
    }
    seachDosageCode(event: any) {
  
    }
    removeRow(x) {
      const index: number = this.SelectedMedicineArray.indexOf(x);
      if (index !== -1) {
        this.SelectedMedicineArray.splice(index, 1);
        this.selection.toggle(x);
      }
  
    }
  
 
    
    changeTableRowColor(idx: any) {
      
      if (this.rowClicked === idx) {
  
        this.rowClicked = -1;
        this.medicine_ds = new MatTableDataSource(this.medicinearray.slice());
      }
      else {
        this.rowClicked = idx;
      }
    }
  
  
    deActiveMaster: any = {};
    deActiveMedcine(element, type) {
      this.deActiveMaster = {};
      if (type == 1) {
        this.deActiveMaster = element;
        document.getElementById("deActiveMedicineModal").style.display = "block";
      } else {
        this.deActiveMaster = {};
        document.getElementById("deActiveMedicineModal").style.display = "none";
      }
  
    }
  
    deActiveMedicielist(medobject) {
      this.showspinner = true;
      let payload = {
        "MedicineMaster":
        {
          "IsEdit": true, "IsDelete": false, "PK_MedicineId": medobject.pK_MedicineId,
          "MedicineName": medobject.medicineName,
          "FK_CategoryId": medobject.fK_CategoryId,
          "FK_MfgId": medobject.fK_MfgId,
          "FK_RouteId": medobject.fK_RouteId,
          "Qty": medobject.qty,
          "FK_TypeId": medobject.fK_TypeId ? medobject.fK_TypeId : null,
          "FK_DosageId": medobject.fK_DosageId,
          "Days": medobject.days,
          "DaysUnit": medobject.daysUnit,
          "DrugName": medobject.drugName,
          "remarks": medobject.remarks,
          "IsActive": false,
          "Fk_itemid": medobject.fk_itemid ? medobject.fk_itemid : null,
          "AlterNateMedicine": medobject.alterNateMedicine,
          "QtyUnit": medobject.qtyUnit,
        }
      }
      this.emrService.InsertMedicineMaster(payload).pipe(takeUntil(this.destroy$)).subscribe((x: any) => {
        this.showspinner = false;
        if (x['statusCode'] == 1) {
          document.getElementById("deActiveMedicineModal").style.display = "none";
          this.dashboardService.openSnackBar("Record De-Actived Successfully", "OK");
          this.GetMedicineMaster(0,0,0,0);
        }
      }, err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
        this.showspinner = false;
        this.dashboardService.openSnackBar("API Failed :" + err.status + " Internal Server Error", "OK");
        if(this.popbutton >0){
          this.closedailog()
        }
      });
    }
  
      dosageMaster() {
      const dialogRef = this.dialog.open(DosageMasterComponent, {
        width: '900px',
        height:'auto',
        data: {
          id: 1,
        }     
       });
    
      dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed');
      });    }
    canceldosageMaster() {
      this.clearData();
      document.getElementById("dosageMasterModal").style.display = "none";
    }
    clearData() {
      this.dosageMasterdataModel = [];
      this.dosageMasterdataobj = {};
      this.dosageTimedetails = [];
      this.dosageTimedetailsobj = {};
      this.dosageMasterdataobj.fK_LanguageId = 1;
    }
   
    color: any;
    _value: number = 0;
    _hourvalue: number = 0;
    _step: number = 1;
    _min: number = 0;
    _max: number = 60;
    _hourmax: number = 12;
    _wrap: boolean = false;
  
    myFormGroup = new FormGroup({
      formField: new FormControl(),
    });
  
    set inputValue(_value: number) {
      this._value = this.parseNumber(_value);
    }
  
    set step(_step: number) {
      this._step = this.parseNumber(_step);
    }
  
    set min(_min: number) {
      this._min = this.parseNumber(_min);
    }
  
    set max(_max: number) {
      this._max = this.parseNumber(_max);
    }
  
    set hourmax(_hourmax: number) {
      this._hourmax = this.parseNumber(_hourmax);
    }
  
    set wrap(_wrap: boolean) {
      this._wrap = this.parseBoolean(_wrap);
    }
  
    private parseNumber(num: any): number {
      return +num;
    }
  
    private parseBoolean(bool: any): boolean {
      return !!bool;
    }
  
    setColor(color: string): void {
      this.color = color;
    }
  
    getColor(): string {
      return this.color;
    }
  
    incrementValue(step: number = 1): void {
      let inputValue = this._value + step;
  
      if (this._wrap) {
        inputValue = this.wrappedValue(inputValue);
      }
      this._value = inputValue;
    }
  
    hoursincrementValue(step: number = 1): void {
      let hourinputValue = this._hourvalue + step;
  
      if (this._wrap) {
        hourinputValue = this.hourwrappedValue(hourinputValue);
      }
  
      this._hourvalue = hourinputValue;
    }
  
    private wrappedValue(inputValue): number {
      if (inputValue > this._max) {
        return this._min + inputValue - this._max;
      }
  
      if (inputValue < this._min) {
        if (this._max === 12) {
          return 0;
        }
  
        return this._max + inputValue;
      }
  
      return inputValue;
    }
  
    private hourwrappedValue(hourinputValue): number {
      if (hourinputValue > this._hourmax) {
        return this._min + hourinputValue - this._hourmax;
      }
  
      if (hourinputValue < this._min) {
        if (this._hourmax === 60) {
          return 0;
        }
  
        return this._hourmax + hourinputValue;
      }
  
      return hourinputValue;
    }
  
    shouldDisableDecrement(inputValue: number): boolean {
      return !this._wrap && inputValue <= this._min;
    }
  
    shouldDisableIncrement(inputValue: number): boolean {
      return !this._wrap && inputValue >= this._max;
    }
  
  
    hourshouldDisableDecrement(hourinputValue: number): boolean {
      return !this._wrap && hourinputValue <= this._min;
    }
  
    hourshouldDisableIncrement(hourinputValue: number): boolean {
      return !this._wrap && hourinputValue >= this._hourmax;
    }
  
    changeFormat(event: any) {
      this.timeFormatcheck = event;
    }
    // add time
    timeFormatArray: any = [];
    addTime(hr, min) {
      
      let bindtime = hr + ':' + min + ' ' + this.timeFormatcheck;
      this.timeFormatArray.push({
        "dosageTime": bindtime
      });
    }
    //delete time 
    deletetime(index) {
      this.timeFormatArray.splice(index, 1);
    }
    //transfer dosage time
    TransferDosagetime(rowdata: any) {
      
      if (rowdata.length > 0) {
        rowdata.forEach(item => {
          this.dosageTimedetails.push({
            "pK_DosageTimeDetailId": 0,
            "fK_DosageId": 0,
            "dosageTime": item.dosageTime,
            "isActive": true, "isEdit": false,
            "isDelete": false
          });
        });
  
      }
    }
   
    //Search Record 
    searchRecord() {
      document.getElementById("searchRecordModal").style.display = "block";
    }
    cancelsearchRecord() {
      document.getElementById("searchRecordModal").style.display = "none";
    }
  
    doaseRowdata(row: any) {
      this.dosageMasterdataobj = row;
      this.GetDosageTimeDetailByDosageId(row.pK_DosageId);
      this.GetDosageDescriptionMasterByDosageId(row.pK_DosageId);
      document.getElementById("searchRecordModal").style.display = "none";
    }
  
  
    //Medicine Master
    medicineMaster() {
      this.addmedicineobject={}
      document.getElementById("medicineMasterModal").style.display = "block";
    }
    cancelmedicineMaster() {
      document.getElementById("medicineMasterModal").style.display = "none";
    }
  
  
    //Medicine Search Record 
    medicineSearchRecord() {
      document.getElementById("medicineSearchRecordModal").style.display = "block";
      this.GetMedicineMaster(0,0,0,0);
    }
    cancelmedicineSearchRecord() {
      document.getElementById("medicineSearchRecordModal").style.display = "none";
      this.searchValue = ''
    }
  
    //Medicine Manufacture Master
    medicineManufactureMaster() {
      const dialogRef = this.dialog.open(MedicineManufacturerMasterComponent, {
        width: '900px',
        height:'auto',
        maxHeight:'40vh',
        data: {
          id: 1,
        }     
       });
    
      dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed');
      });    
     }

  
  
    //Medicine Type
    medicineType() {
      document.getElementById("medicineTypeModal").style.display = "block";
    }
    cancelmedicineType() {
      document.getElementById("medicineTypeModal").style.display = "none";
    }
  
  
    //Add Medicine Type
    addmedicineType() {
      document.getElementById("addMedicineTypeModal").style.display = "block";
    }
    cancelAddmedicineType() {
      document.getElementById("addMedicineTypeModal").style.display = "none";
    }
  
  
    //Quantity Unit
    quantityUnit() {
      document.getElementById("quantityUnitModal").style.display = "block";
    }
    cancelquantityUnit() {
      document.getElementById("quantityUnitModal").style.display = "none";
    }
  
    exportexcel(type: any, ctype: any): void {
  
      this.exportdata.open_loader_Dialogtwo();
      let element = document.getElementById(ctype);
      this.exportdata.Newexportxcel(element, type);
  
    }
  
    getRoutedata(routeid) {
      this.routemainArray = [];
      this.emrService.getRouteMaster(routeid).pipe(takeUntil(this.destroy$)).subscribe((x: any) => {
        this.routemainArray = x.filter(item => item.isActive == true);
      })
    }
    getRowdata(row: any) {
      this.addmedicineobject = row;
      document.getElementById("medicineSearchRecordModal").style.display = "none";
    }
    fieldsChange(event) {
      this.addmedicineobject.isActive = event.target.checked;
    }
    addNewMedicine() {  
      this.showspinner = true;
      if (this.addmedicineobject.pK_MedicineId == 0 || !this.addmedicineobject.pK_MedicineId) {
        const existingMedicine = this.medData.filter(medicine =>
          medicine.medicineName.toLowerCase() == this.addmedicineobject.medicineName.toLowerCase()
        );
    
        if (existingMedicine.length > 0) {
          this.dashboardService.openSnackBar("Already exists in the list", "OK");
          this.showspinner = false;
          this.addmedicineobject = {};
          return;  
        }
      }
      let payload = {
        "MedicineMaster":
        {
          "IsEdit": this.addmedicineobject.pK_MedicineId ? true : false, "IsDelete": false, "PK_MedicineId": this.addmedicineobject.pK_MedicineId ? this.addmedicineobject.pK_MedicineId : 0,
          "MedicineName": this.addmedicineobject.medicineName,
          "FK_CategoryId": this.addmedicineobject.fK_CategoryId,
          "FK_MfgId": this.addmedicineobject.fK_MfgId,
          "FK_RouteId": this.addmedicineobject.fK_RouteId ? this.addmedicineobject.fK_RouteId : null,
          "Qty": this.addmedicineobject.qty,
          "FK_TypeId": this.addmedicineobject.fK_TypeId ? this.addmedicineobject.fK_TypeId : null,
          "FK_DosageId": this.addmedicineobject.fK_DosageId,
          "Days": this.addmedicineobject.days,
          "DaysUnit": this.addmedicineobject.daysUnit,
          "DrugName": this.addmedicineobject.drugName,
          "remarks": this.addmedicineobject.remarks,
          "IsActive": this.addmedicineobject.isActive ? true : false,
          "Fk_itemid": this.addmedicineobject.fk_itemid ? this.addmedicineobject.fk_itemid : null,
          "AlterNateMedicine": this.addmedicineobject.alterNateMedicine,
          "QtyUnit": this.addmedicineobject.qtyUnit,
        }
      }
      this.emrService.InsertMedicineMaster(payload).pipe(takeUntil(this.destroy$)).subscribe((x: any) => {
        this.showspinner = false;
        if (x['statusCode'] == 1) {
          if (this.addmedicineobject.pK_MedicineId > 0) {
            this.dashboardService.openSnackBar("Record updated successfully", "OK");
          } else {
            this.dashboardService.openSnackBar("Record saved successfully", "OK");
          }
          this.GetMedicineMaster(0,0,0,0);
          this.addmedicineobject = {};
        }
      }, err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
        this.showspinner = false;
        if(this.popbutton >0){
          this.closedailog()
        }
      });
    }
  
  
    refReasonPOpup(type) {
      const dialogRef = this.dialog.open(HelpListPopupComponent, {
        panelClass: 'full-width-dialog',
        maxWidth: '33vw',
        disableClose: true,
        width: '33%',
  
        data: {
          typeid: type
        }
  
      });
  
      dialogRef.afterClosed().subscribe(result => {
        
        if (result != 0) {
          if (type == 1) {
            this.addmedicineobject.type = result;
            this.gethelpListpopupdata('MedicineType', this.addmedicineobject.type);
          }
        }
      });
    }
    helplistArray: any = [];
    gethelpListpopupdata(type: any, typedesc: any) {
      this.helplistArray = [];
      this.emrService.GetPopUpHelp(type).pipe(takeUntil(this.destroy$)).subscribe((x: any) => {
        this.helplistArray = x.filter(item => item.isActive == true);
        let typeid = this.helplistArray.filter(item => item.popupDescription.toLowerCase() == typedesc.toLowerCase());
        this.addmedicineobject.fK_TypeId = typeid[0]?.pkPopupId;
      });
    }
    // helplist pop up 
    refsaltPOpup() {
      const dialogRef = this.dialog.open(DynamicHelpListComponent, {
        panelClass: 'full-width-dialog',
        maxWidth: '33vw',
        disableClose: true,
        width: '33%',
        data: {
          parametertype: 'SaltName'
        }
  
      });
  
      dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {
        if (result != 0) {
          this.addmedicineobject.drugName = result;
  
        }
      });
    }
    checkMasterobject:any=[]
    AddMultLangDosage() {
      this.dosageMasterdataModel.push({
        pK_TranId: 0,
        pK_DosageId: 0,
        fK_LanguageId: this.dosageMasterdataobj.fK_LanguageId,
        dosageDescription: this.dosageMasterdataobj.dosageDescription,
        fontName: this.dosageMasterdataobj.fontName,
        isActive: this.dosageMasterdataobj.isActive,
        pK_SynchId: null,
        isEdit: false,
        isDelete: false,
  
      });
      this.checkMasterobject=this.dosageMasterdataModel[0];
    }
  
    descriptionMaster: any = [];
    timeDetail: any = [];
    dosmasterobj = {};
 
    convertTo24Hour(s) {
      var time = s.split(':');
      var hours = parseInt(time[0]);
      var _ampm = time[1];
      if (_ampm.indexOf('AM') != -1 && hours == 12) {
        time[0] = '00';
      }
      if (_ampm.indexOf('PM') != -1 && hours < 12) {
        time[0] = hours + 12;
      }
      return time.join(':').replace(/(AM|PM)/, '');
    }
    convertTo12formatTime(rowdata) {
      
      if(rowdata.pK_DosageTimeDetailId >0){
        const [hourString, minute] = rowdata.dosageTime.split(":");
        const hour = +hourString % 24;
        return (hour % 12 || 12) + ":" + minute + (hour < 12 ? "AM" : "PM");
      }else{
        return rowdata.dosageTime;
      }
     
  }
    GetDosageTimeDetailByDosageId(id){
      this.dosageTimedetails =[];
      this.emrService.GetDosageTimeDetailByDosageId(id).pipe(takeUntil(this.destroy$)).subscribe((x:any)=>{
        if(x.length >0){
          this.dosageTimedetails =x;
        }
      })
    }
    GetDosageDescriptionMasterByDosageId(id){
      this.dosageMasterdataModel =[];
      this.emrService.GetDosageDescriptionMasterByDosageId(id).pipe(takeUntil(this.destroy$)).subscribe((x:any)=>{
        if(x.length >0){
          this.dosageMasterdataModel =x;
        }
      });
    }
    chngedosageDesc(keyvalue,i){
        if(keyvalue != null){
          this.dosageMasterdataModel[i].dosageDescription=keyvalue;
        }
    }
     deleteDescarray:any=[];
     deletetimemaster:any=[];
 
    applyFilter(filterValue: string) {
      this.medicinecategories_ds.filter = filterValue.trim().toLowerCase();
    }
  
    refReasondyamicPOpup(parameter) {
      const dialogRef = this.dialog.open(DynamicHelpListComponent, {
        panelClass: 'full-width-dialog',
        maxWidth: '33vw',
        disableClose: true,
        width: '33%',
  
        data: {
          parametertype: parameter
        }
  
      });
  
      dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {
     
        if (result != 0) {
        
            this.addmedicineobject.qtyUnit =result;
          }
      });
    }
    
    clearForm(){
      this.addmedicineobject = {};
    }

    medicineCategoryMaster(): void {
      const dialogRef = this.dialog.open(MedicineCatgeoryMasterComponent, {
        width: '800px',
        height:'auto',
        maxHeight:'40vh',
        data: {
          id: 1,
        }     
       });
    
      dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed');
      });
    }
    medicineCategoryMainarray: any = [];
    GetMedicineCategoryMaster(medcineid) {
      this.medicineCategoryMainarray = [];
      this.emrService.GetMedicineCategoryMaster(medcineid).pipe(takeUntil(this.destroy$)).subscribe(data => this.successCategory(data), err => this.failed_category(err))
    }
  
    successCategory(data) {
      this.medicineCategoryMainarray = data;
      let filterdata = this.medicineCategoryMainarray.filter(item => item.isActive == true);
      this.medicinecategories_ds = new MatTableDataSource(filterdata.slice());
  
    }

    closedailog(){
      this.dialogRef.close(); 
    }

  }
  